import React from 'react'

function Checkbox({ label, ...rest }) {
    return (
        <div className='flex items-center gap-2 text-sm font-medium'>
            <input type="checkbox" {...rest} />
            {label && (
                <p className="">{label}</p>
            )}
        </div>
    )
}

export default Checkbox